import { IconButton, IconButtonProps, Tooltip } from "@chakra-ui/react"
import { FramerBox } from "@components/animations/FramerBox"

const FooterIconButton = ({
  animateX,
  ...rest
}: IconButtonProps & { animateX: number[] }) => {
  return (
    <FramerBox
      key={rest["aria-label"]}
      initial={{ opacity: 0 }}
      animate={{
        opacity: [1],
        scale: [1],
        rotate: [0],
        x: animateX,
        y: [0],
      }}
      // @ts-expect-error no problem in operation, although type error appears.
      transition={{
        delay: 2,
        duration: 1,
        ease: "easeInOut",
      }}
    >
      <Tooltip
        label={rest["aria-label"]}
        placement={"auto"}
        bg={"whitesmoke"}
        color={"brand.black"}
        fontSize={"md"}
        fontWeight={"normal"}
        borderRadius={"md"}
        px={4}
      >
        <IconButton
          isRound
          fontSize={{ base: "2xl", xl: "3xl" }}
          px={4}
          py={4}
          h={{ base: 14, xl: 16 }}
          zIndex={10}
          shadow={"md"}
          position={"absolute"}
          _hover={{
            transform: "scale(1.2)",
          }}
          {...rest}
        />
      </Tooltip>
    </FramerBox>
  )
}

export default FooterIconButton
